import React, { Component } from "react";
import Link from "gatsby-link";

import Logo from './logo';
import MenuButton from './menuButton';
import Drawer from './drawer';

class Header extends Component {

  state = {
    drawerOpen: false
  };

  handleClick = e => {
    this.setState(prevState => {
      return { drawerOpen: !prevState.drawerOpen };
    });
  };

  render (props) {

  return (

    <nav id="nav" className={['fixed', 'w-full', 'pin-t', 'pin-l', 'py-4', 'px-6', 'transition',
    'md:py-6', 'md:bg-transparent', 'md:h-full', 'md:w-auto', 'bg-white'].join(" ")}>

      <div 
      onClick={this.handleClick}
      className="flex flex-wrap justify-between h-full
      md:flex-col md:content-between">

        <Logo white={this.props.logowhite} open={this.state.drawerOpen}/>

        <MenuButton white={this.props.menuwhite} open={this.state.drawerOpen}/>

        <Drawer open={this.state.drawerOpen}/>

      </div>

    </nav>

  )};

};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js